import { render, staticRenderFns } from "./ApiDetails.vue?vue&type=template&id=913f877c&scoped=true&"
import script from "./ApiDetails.vue?vue&type=script&lang=js&"
export * from "./ApiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913f877c",
  null
  
)

export default component.exports